import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import ConnectionMotif from "@/components/ConnectionMotif";
import FiberUnderline from "@/components/FiberUnderline";

function useCountdown(targetIso) {
  const calc = () => {
    const target = new Date(targetIso).getTime();
    const now = Date.now();
    let diff = Math.max(0, target - now);
    const days = Math.floor(diff / 86400000);
    diff -= days * 86400000;
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000);
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000);
    return { days, hours, minutes, seconds };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setTime(calc), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetIso]);
  return time;
}

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown({ targetIso }) {
  const t = useCountdown(targetIso);
  const units = [
    { label: "Giorni", value: t.days },
    { label: "Ore", value: pad(t.hours) },
    { label: "Minuti", value: pad(t.minutes) },
    { label: "Secondi", value: pad(t.seconds) },
  ];

  return (
    <section className="relative isolate overflow-hidden px-6 py-24 md:py-32" data-testid="countdown-section">
      <ConnectionMotif color="#e60000" color2="#e60000" className="-z-10 opacity-[0.16]" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0f0f13]/50 to-transparent" />
      <div className="relative mx-auto max-w-5xl text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-display text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl text-glow-magenta"
        >
          LA SFIDA STA PER INIZIARE
        </motion.h2>
        <FiberUnderline center />

        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
          {units.map((u, i) => (
            <motion.div
              key={u.label}
              initial={{ opacity: 0, scale: 0.85 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="rounded-2xl border border-white/10 bg-[#0f0f13] py-8"
              data-testid={`countdown-${u.label.toLowerCase()}`}
            >
              <div className="scoreboard-num text-5xl font-black tabular-nums sm:text-6xl md:text-7xl">
                {u.value}
              </div>
              <div className="mt-2 text-xs uppercase tracking-[0.3em] text-white/40">{u.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
